module.exports = __webpack_public_path__ + "static/media/slider_3_master_user_es.1decc6e8.svg";